export * from "./error-message";
import ErrorMessage from "./error-message";
export default ErrorMessage;
